import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { FiSearch, FiUser, FiLogOut, FiMenu, FiSave, FiX } from 'react-icons/fi';
import ProfileModal from '../modals/ProfileModal'; // import your modal
import './Header.css';
const url = process.env.REACT_APP_BACKEND_URL;

const Header = () => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchQuery);
    setSearchQuery('');
  };

  return (
    <header className="app-header">
      {/* Mobile menu button */}
      <button className="mobile-menu-btn">
        <FiMenu />
      </button>

      {/* Search Bar */}
      <div className="search-container">
        <form onSubmit={handleSearch} className="search-form">
          <div className="search-input-group">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>
        </form>
      </div>

      {/* Header Actions */}
      <div className="header-actions">
        {/* User Profile */}
        <div className="user-profile-container">
          <button
            className="user-profile-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="user-avatar">
              {user?.avatar ? <img src={user.avatar} alt={user?.name} /> : <FiUser />}
            </div>
            <div className="user-info">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">{user?.role}</span>
            </div>
          </button>

          {/* Dropdown Menu */}
          {showDropdown && (
            <div className="dropdown-menu">
              {/* User Profile Info */}
              <div className="dropdown-header">
                <div className="dropdown-avatar">
                  {user?.avatar ? <img src={user.avatar} alt={user?.name} /> : <FiUser />}
                </div>
                <div className="dropdown-user-info">
                  <span className="dropdown-name">{user?.name}</span>
                  <span className="dropdown-email">{user?.email}</span>
                </div>
              </div>

              <div className="dropdown-divider"></div>

              {/* Edit Profile Button */}
              <button
                className="dropdown-item"
                onClick={() => {
                  setShowProfileModal(true);
                  setShowDropdown(false);
                }}
              >
                <FiUser className="dropdown-icon" />
                <span>Edit Profile</span>
              </button>

              <div className="dropdown-divider"></div>

              {/* Logout */}
              <button className="dropdown-item logout-item" onClick={handleLogout}>
                <FiLogOut className="dropdown-icon" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Overlay for closing dropdown */}
      {showDropdown && (
        <div className="dropdown-overlay" onClick={() => setShowDropdown(false)} />
      )}

      {/* Profile Modal */}
      <ProfileModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </header>
  );
};

export default Header;
